(function ($) {
    'use strict';

    function CollapsibleCard() {
        var $card,
            $toggler,
            $body = $('html, body'),
            cardPosition,
            bodyPosition;

        $('.faqs-toggler').click(function () {
            var isExpanded = $(this).attr('aria-expanded');

            if (isExpanded === 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        });

        $('.collapsible-card .collapse').on('hide.bs.collapse', function () {

            $card = $(this).closest('.collapsible-card');
            cardPosition = $card.offset().top;
            bodyPosition = $body.scrollTop();

            if ($card !== 'undefined') {
                if ( cardPosition < bodyPosition ) {
                    $body.animate({ scrollTop: cardPosition }, 200);
                }
            }
        });

    };

    window.CollapsibleCard = CollapsibleCard;
}(jQuery));
